const forEach = (elements, callback) => {
    Array.prototype.forEach.call( elements, callback );
};

export default forEach;